import { Component, Vue, Prop} from 'vue-property-decorator'

@Component
export default class BarChart extends Vue {
  @Prop({ default: () => ([]) }) readonly columns: Array<any>
  @Prop({ default: () => ([]) }) readonly dataValue: any
  color = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF']

  mounted() {
    this.init()
  }

  seriesDataItem(obj) {
    const data = []
    Object.keys(obj).sort().forEach(function(key) {
      const value = obj[key] * 100
      data.push(value.toFixed(2))
    })
    return data
  }

  mathDataLength() {
    return (90 / this.dataValue.length).toFixed(2)
  }

  init() {
    const seriesData = []
    /*const xAxisData = []

    const legendData = []
    this.columns.forEach(item => {
      xAxisData.push(item.title)
    })*/
    this.dataValue.forEach(res => {
      const seriesValue = {
        name: res.workStationName,
        type: 'bar',
        label: {
          show: true,
          position: 'top'
        },
        data: res
      }
      // legendData.push(res.workStationName)
      seriesData.push(seriesValue)
    })
    // 基于准备好的dom，初始化echarts实例
    var myChart = (this as any).$echarts.init(
      this.$refs.myChart as any
    )
    // 指定图表的配置项和数据
    var option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        show: false
      },
      grid: {
        top: '30',
        left: '20',
        right: '40',
        bottom: '4%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLabel: {
          show: true,
          interval: 0
        },
        axisLine: { onZero: true },
        data: this.columns
      },
      color: this.color,
      yAxis: [
        {
          type: 'value',
          boundaryGap: true,
          axisLine: {
            show: false
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
          /*axisLabel: {
            formatter: value => {
              return value + '%'
            }
          }*/
        }
      ],
      // series: this.dataValue
      series: [{
        type: 'bar',
        barWidth: '30%',
        label: {
          show: true,
          position: 'top'
        },
        data: this.dataValue
      }]
    }
    // 使用刚指定的配置项和数据显示图表。
    myChart.setOption(option)
  }

  render() {
    return (
      <div ref="myChart" style={{
        width: '100%',
        height: '228px'
      }}></div>
    )
  }
}
